var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 31,
    viewBox: "0 0 24 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9165 30.125C4.13734 30.125 3.47032 29.8068 2.91546 29.1703C2.3606 28.5339 2.08317 27.7687 2.08317 26.875V5.75H0.666504V2.5H7.74984V0.875H16.2498V2.5H23.3332V5.75H21.9165V26.875C21.9165 27.7687 21.6391 28.5339 21.0842 29.1703C20.5294 29.8068 19.8623 30.125 19.0832 30.125H4.9165ZM19.0832 5.75H4.9165V26.875H19.0832V5.75ZM7.74984 23.625H10.5832V9H7.74984V23.625ZM13.4165 23.625H16.2498V9H13.4165V23.625Z",
    fill: "#1D1B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.251adf5687f3594341bbf1a2ec449b25.svg";
export { ForwardRef as ReactComponent };